/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
const $ = jQuery;

// Continue autoplaying videos after Fancybox closes
Fancybox.bind('[data-fancybox]', {
	on: {
		closing: (fancybox, slide) => {
			$('.block-cta-corner iframe').each(function () {
				const vimeo = new Vimeo.Player($(this)[0]);
				vimeo.play();
			});
		},
	},
});
